export const styles = theme => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontWeight: 500,
    '&:nth-of-type(even)': {
      // borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
    border: '1px solid #ccc',
  },
  active_tab: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
  },
  container: {
    maxHeight: 506,
  },
  icon: {
    padding: theme.spacing(0),
  },

  // color
  status: {
    borderRadius: 4,
  },
  colorRedMax: {
    background: '#B02418',
    color: '#fff',
  },
  colorRed: {
    background: '#EA3423',
    color: '#fff',
  },
  colorYellow: {
    background: '#F7C142',
  },
  colorGreen: {
    background: '#4EAC5B',
    color: '#fff',
  },
});